import get from 'lodash/get';

const isEqual = (child?: any, assertion?: any) => (
  child !== null && (typeof child.type === 'string' ? child.type : get(child, 'type.displayName')) === assertion
);

const childTypeEquals = (child?: any, assertion?: any) => {
  if (Array.isArray(assertion)) {
    return assertion.some((type?: any) => isEqual(child, type));
  }

  return isEqual(child, assertion);
};

export default childTypeEquals;
